export default __webpack_public_path__ + "4d7cd3ab8f75c13fbf2459c33e519083.png";